import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import Figure from "../figure"

const Selfie = () => (
  <Figure
    caption={<>A selfie that Aliou Candé sent<br className="nm" /> soon after his arrival in Libya.</>}
    maxWidth="20em"
    width="80%"
    //credit="Photo courtesy Jacaria Candé"
  >
    <StaticImage
      src="../../../images/mabani/aliou-cande-3.jpg"
      alt=""
    />
  </Figure>
);

export default Selfie;